import React from "react";
import { Button } from "@mui/material";

const DSErrorButton = (props: React.ComponentProps<typeof Button>) => {
  return <Button color="error" variant="outlined" {...props} />;
};

export default DSErrorButton;
